import { render, staticRenderFns } from "./AccessShipmentsModal.vue?vue&type=template&id=75f9a6bc"
import script from "./AccessShipmentsModal.vue?vue&type=script&lang=js"
export * from "./AccessShipmentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports